// 登录页面
export default {
    rememberPassword: '记住密码',
    enterName: '请输入用户名',
    enterPassword: '请输入密码',
    forget: '忘记密码?',
    login: '登录',
    loggingIn: '登录中',
    userLogin: '用户登录',
    loginSuccess: '登录成功',
    VCL: '验证码登录',
    PEPN: '请输入手机号',
    VC: '请输入验证码',
    FR: '注册',
    FP: '忘记密码',
    GVC: '获取验证码',
    changePassword: '修改密码',
    tip_PEVC: '请输入验证码',
    tip_IVC: '验证码不正确',
    tip_MPN: '手机号格式错误',
    tip_VCFE: '验证码格式错误',
    tip_PCYP: '请确认密码',
    tip_P: '必须包含大小写字母和数字，可以使用特殊字符，长度在8-20之间',
    tip_TT: '两次输入密码不一致!',
    tip_N: '中文、英文、数字但不包括下划线等符号',
    tip_RS: '注册成功',
    tip_PRS: '密码重置成功',
    tip_PET: '请输入旧密码',
    tip_PEA: '请输入新密码',
    tip_PIU: '请输入账号',
    generalUser: '普通用户',
    businessUser: '企业用户',
}